import { Observable, RequestType, startFetchProxy, startXhrProxy, } from '@datadog/browser-core';
import { isAllowedRequestUrl } from './resourceUtils';
import { startTracer } from './tracer';
var nextRequestIndex = 1;
export function startRequestCollection(configuration) {
    var requestObservables = [new Observable(), new Observable()];
    var tracer = startTracer(configuration);
    trackXhr(configuration, requestObservables, tracer);
    trackFetch(configuration, requestObservables, tracer);
    return requestObservables;
}
export function trackXhr(configuration, _a, tracer) {
    var requestStartObservable = _a[0], requestCompleteObservable = _a[1];
    var xhrProxy = startXhrProxy();
    xhrProxy.beforeSend(function (context, xhr) {
        if (isAllowedRequestUrl(configuration, context.url)) {
            var tracingResult = tracer.traceXhr(context, xhr);
            if (tracingResult) {
                context.traceId = tracingResult.traceId;
                context.spanId = tracingResult.spanId;
            }
            context.requestIndex = getNextRequestIndex();
            requestStartObservable.notify({
                requestIndex: context.requestIndex,
            });
        }
    });
    xhrProxy.onRequestComplete(function (context) {
        if (isAllowedRequestUrl(configuration, context.url)) {
            requestCompleteObservable.notify({
                duration: context.duration,
                method: context.method,
                requestIndex: context.requestIndex,
                response: context.response,
                spanId: context.spanId,
                startTime: context.startTime,
                status: context.status,
                traceId: context.traceId,
                type: RequestType.XHR,
                url: context.url,
            });
        }
    });
    return xhrProxy;
}
export function trackFetch(configuration, _a, tracer) {
    var requestStartObservable = _a[0], requestCompleteObservable = _a[1];
    var fetchProxy = startFetchProxy();
    fetchProxy.beforeSend(function (context) {
        if (isAllowedRequestUrl(configuration, context.url)) {
            var tracingResult = tracer.traceFetch(context);
            if (tracingResult) {
                context.traceId = tracingResult.traceId;
                context.spanId = tracingResult.spanId;
            }
            context.requestIndex = getNextRequestIndex();
            requestStartObservable.notify({
                requestIndex: context.requestIndex,
            });
        }
    });
    fetchProxy.onRequestComplete(function (context) {
        if (isAllowedRequestUrl(configuration, context.url)) {
            requestCompleteObservable.notify({
                duration: context.duration,
                method: context.method,
                requestIndex: context.requestIndex,
                response: context.response,
                responseType: context.responseType,
                spanId: context.spanId,
                startTime: context.startTime,
                status: context.status,
                traceId: context.traceId,
                type: RequestType.FETCH,
                url: context.url,
            });
        }
    });
    return fetchProxy;
}
function getNextRequestIndex() {
    var result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}
//# sourceMappingURL=requestCollection.js.map